import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  SalesListingDetailViewModel,
  SalesListingDocumentViewModel,
} from '@core/api';
import { Gallery, GalleryItem, ImageItem } from 'ng-gallery';
import { SearchService } from '../../../services/search.service';

@Component({
  selector: 'app-sales-item-details',
  templateUrl: './sales-item-details.component.html',
  styleUrls: ['./sales-item-details.component.scss'],
  standalone: false,
})
export class SalesItemDetailsComponent implements OnInit, OnChanges {
  @Input() location: SalesListingDetailViewModel & { city?: string };
  @Output() goBack = new EventEmitter<void>();
  @ViewChild('saleItemDetails', { static: true })
  saleItemDetails: ElementRef;

  selectedFile: string | null = null;
  galleryId: string;
  items: GalleryItem[];
  isDesktopView: boolean = true;

  pdfList: SalesListingDocumentViewModel[] = [];

  constructor(
    public gallery: Gallery,
    private readonly searchService: SearchService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.pdfList =
      this.location.files?.filter(file => file.isImage === false) || [];

    this.initializeGalleryId();
    this.loadCityForLocation();
    this.initializeItems();
    this.loadGalleryItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.location?.currentValue) {
      this.initializeGalleryId();
      this.loadCityForLocation();
      this.initializeItems();
      this.loadGalleryItems();
    }
  }

  /**
   * Initializes the gallery ID based on the location ID.
   */
  private initializeGalleryId(): void {
    this.galleryId = `saleItemLightbox${this.location.id}`;
  }

  /**
   * Initializes the gallery items based on the location files.
   */
  private initializeItems(): void {
    const imageFileExtensions = [
      'jpg',
      'jpeg',
      'png',
      'gif',
      'tif',
      'webp',
      'tiff',
    ];
    this.items = this.location.files
      ?.filter(file => {
        const fileExtension = file.fileName.split('.').pop().toLowerCase();
        return imageFileExtensions.includes(fileExtension);
      })
      .map(file => new ImageItem({ src: file.downloadUri, thumb: file.uri }));
  }

  /**
   * Loads the gallery items into the gallery reference.
   */
  private loadGalleryItems(): void {
    const galleryRef = this.gallery.ref(this.galleryId);
    galleryRef.setConfig({
      imageSize: 'contain',
      thumb: false,
      dots: true,
      counter: false,
    });
    galleryRef.load(this.items);
  }

  /**
   * Loads the city name for the current location based on its coordinates.
   */
  private loadCityForLocation(): void {
    this.searchService
      .getCityFromCoordinates(this.location.latitude, this.location.longitude)
      .then(city => {
        this.location.city = city;
      })
      .catch(error => {
        console.error('Error retrieving city:', error);
      });
  }

  routeToContactForm() {
    this.router.navigateByUrl('/landing/contact');
  }

  /**
   * Opens the lightbox (for keyboard control)
   */
  openLightbox(index: number): void {
    const previews = document.querySelectorAll('.file-preview');
    const el = previews[index] as HTMLElement;
    if (el) {
      el.click();
    }
  }
}
